import { Component } from '@angular/core';

@Component({
  selector: 'app-chat-bot-page',
  templateUrl: './chat-bot-page.component.html',
  styleUrls: ['./chat-bot-page.component.scss']
})
export class ChatBotPageComponent {}
